export default __webpack_public_path__ + "static/media/nodata.e566be3b.webp";